import { Box, Link, Text } from '@factorialco/deprecated-design-system'

interface CustomTwoColumnsListProps {
  list: {
    title: string
    info: string | null | undefined
    link?: string
    customInfoBlock?: React.ReactNode
  }[]
}

const Item = ({
  title,
  customInfoBlock,
  info,
  link,
}: {
  title: string
  customInfoBlock?: React.ReactNode
  info: string
  link: string | undefined
}) => (
  <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center">
    <Box style={{ width: '160px' }} alignSelf="flexStart">
      <Text size="200" weight="normal" color="grey800">
        {title}
      </Text>
    </Box>
    <Box width="s300">
      {customInfoBlock ? (
        customInfoBlock
      ) : link ? (
        <Link.Router external to={link}>
          {info}
        </Link.Router>
      ) : (
        <Text size="200" weight="semibold" color="grey1000" whiteSpace="breakSpaces">
          {info}
        </Text>
      )}
    </Box>
  </Box>
)

export const CustomTwoColumnsList = ({ list }: CustomTwoColumnsListProps) => {
  return (
    <Box flexDirection="column" gap="s4">
      {list.map((item) => (
        <Item
          key={item.title}
          title={item.title}
          customInfoBlock={item?.customInfoBlock}
          info={item?.info ?? ''}
          link={item?.link}
        />
      ))}
    </Box>
  )
}
